import { ProductList } from "./productList";
import "./style.css";
import "./list.css";
export const Products = () => <ProductList />;
